/* global axios */
// NOTICE: KAPTION-INTEGRATION
// team-location.API.1 — dashboard client for team location (map + admin settings).
import ApiClient from './ApiClient';

class KaptionTeamLocationAPI extends ApiClient {
  constructor() {
    super('kaption_team_location', { accountScoped: true });
  }

  getAgents({ teamId } = {}) {
    return axios.get(`${this.url}/agents`, {
      params: teamId ? { team_id: teamId } : {},
    });
  }

  getAgentPoints(userId, { from, to } = {}) {
    return axios.get(`${this.url}/agents/${userId}/points`, {
      params: { from, to },
    });
  }

  getSettings(params = {}) {
    return axios.get(`${this.url}/settings`, { params });
  }

  updateSettings(settings) {
    return axios.put(`${this.url}/settings`, settings);
  }

  previewExplainer(settings) {
    return axios.post(`${this.url}/settings/preview`, settings);
  }

  rotateWebhookSecret() {
    return axios.post(`${this.url}/settings/rotate_webhook_secret`);
  }
}

export default new KaptionTeamLocationAPI();
